import type { ReactNode } from "react";
import { ChevronDown } from "lucide-react";
import "./reportDisclosure.css";

type Props = { className: string; heading: ReactNode; children: ReactNode; collapsible?: boolean };

export default function ReportSection({ className, heading, children, collapsible = false }: Props) {
  if (!collapsible) return <section className={className}>{heading}{children}</section>;
  // Native disclosure keeps the table mounted, including its existing Excel
  // registrations and view state, while starting with only the heading visible.
  return <details className={className + " report-disclosure"}>
    <summary className="report-disclosure-toggle">{heading}<ChevronDown size={20} aria-hidden="true" /></summary>
    {children}
  </details>;
}
